/* eslint-disable @typescript-eslint/no-explicit-any */
import IconDefault from '@assets/icons/default.svg?react';
import IconDelete from '@assets/icons/delete.svg?react';
import IconDuplicate from '@assets/icons/duplicate.svg?react';
import IconPlus from '@assets/icons/plus.svg?react';
import IconSave from '@assets/icons/save.svg?react';
import {
 Box,
 Checkbox,
 FormControl,
 FormControlLabel,
 FormGroup,
 IconButton,
 InputLabel,
 Menu,
 MenuItem,
 Select,
 Typography,
 useMediaQuery,
 useTheme,
} from '@mui/material';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import { useConfirmationDialog } from '../../../contexts/useConfirmationDialog';
import { usePage } from '../../../contexts/usePageContext';
import {
 changeCurrentPreset,
 ColPresetType,
 createClientConfigurationStart,
 getClientConfigurationsStart,
 getCurrentPresetStart,
 updateClientConfigurationStart,
} from '../../../redux/clientConfiguration/clientConfigurationSlice';
import { RootState } from '../../../redux/store';
import themeOptions from '../../../utils/theme';
import { updateConfData } from '../ColModal/utils';

export const askName = (configurationItem: any) => {
 const enteredName = prompt('name:');

 if (!enteredName) {
  alert('Empty names not allowed');
  return false;
 }

 if ((configurationItem || []).find((item: any) => item.name === enteredName)) {
  alert('Name already exists');
  return false;
 }
 return enteredName || false;
};

const isPresetChanged = (
 presets: ColPresetType[] | undefined,
 currentPreset: ColPresetType,
) =>
 JSON.stringify(presets?.find((item) => item.name === currentPreset?.name)) !==
 JSON.stringify(currentPreset);

const ModalConf = () => {
 const confName = 'columns';
 const dispatch = useDispatch();
 const { t } = useTranslation();
 const th = useTheme();

 const { pageName } = usePage();

 const { openDialog: openConfirmationDialog } = useConfirmationDialog();

 const clientConfigurationSelector = useSelector(
  (state: RootState) => state.clientConfiguration,
 );

 const currentColumnsPreset =
  clientConfigurationSelector.currentColumnsPreset || null;
 const tempColumnsPreset =
  clientConfigurationSelector.tempColumnsPreset || null;

 const { success, clientConfigurations, presetsColumns } =
  clientConfigurationSelector;

 const configurationItem = clientConfigurations?.find(
  (item) => item.Parameter === confName,
 );
 const configurationItemValue = JSON.parse(
  configurationItem?.Value || '{}',
 ) as { [key: string]: ColPresetType[] };

 const currentPresets = presetsColumns?.[pageName];
 //  console.log(presetsColumns, currentColumnsPreset, tempColumnsPreset);
 const currentPreset: ColPresetType | null = (tempColumnsPreset?.[pageName] ||
  currentColumnsPreset?.[pageName]) as ColPresetType; //  confName === 'columns'  ? ((tempColumnsPreset || currentColumnsPreset) as ColPresetType)  : ((tempFiltersPreset || currentFiltersPreset) as FilterPresetType);

 //  console.log(clientConfigurationSelector);

 const [saveMenuAnchorEl, setSaveMenuAnchorEl] = useState<null | HTMLElement>(
  null,
 );
 const saveMenuOpen = Boolean(saveMenuAnchorEl);

 const wasChanged =
  currentPreset &&
  currentPreset?.name &&
  isPresetChanged(currentPresets, currentPreset);

 const [lastCreated, setLastCreated] = useState<string | null>(null);

 const handleCreate = () => {
  console.log(configurationItem, configurationItemValue);
  // if (!currentPresets) {
  //  alert('Cannot find client conf');
  //  return;
  // }

  const askedName = askName(configurationItemValue?.[pageName] || []);
  if (!askedName) return;

  const name = askedName || 'default';

  const newEntry = {
   name,
  };

  const val = updateConfData(
   configurationItem?.Id || '-1',
   {
    ...configurationItemValue,
    [pageName]: [...(configurationItemValue?.[pageName] || []), newEntry],
   },
   confName,
  );

  if (!configurationItem?.Id) {
   dispatch(createClientConfigurationStart(val));
  } else {
   dispatch(updateClientConfigurationStart(val));
  }

  setLastCreated(name);
 };

 const handleSave = () => {
  if (configurationItem === undefined) return;
  const val = updateConfData(
   configurationItem?.Id || '-1',
   {
    ...configurationItemValue,
    [pageName]: configurationItemValue?.[pageName]?.map((item) => {
     if (item.name === currentPreset?.name) {
      return currentPreset;
     }
     return item;
    }),
   },
   confName,
  );
  if (!configurationItem?.Id) {
   dispatch(createClientConfigurationStart(val));
  } else {
   dispatch(updateClientConfigurationStart(val));
  }
 };

 const handleDelete = () => {
  if (!configurationItem) return;

  openConfirmationDialog({
   title: t('global.delete'),
   message: t('global.deleteMessage'),
   onConfirm: () => {
    const newEntry = configurationItemValue?.[pageName]?.filter(
     (item: any) => item.name !== currentPreset?.name,
    );
    const val = updateConfData(
     configurationItem?.Id || '-1',
     {
      ...configurationItemValue,
      [pageName]: newEntry,
     },
     confName,
    );
    if (!configurationItem?.Id) {
     dispatch(createClientConfigurationStart(val));
    } else {
     dispatch(updateClientConfigurationStart(val));
    }
   },
  });
 };

 const handleDuplicate = () => {
  if (!configurationItem) return;

  const askedName = askName(currentPresets);
  if (!askedName) return;

  const name = askedName || 'default';

  const newItem = configurationItemValue?.[pageName]?.find(
   (i) => i.name === currentPreset?.name,
  );
  const newEntry = [
   ...(configurationItemValue?.[pageName] || []),
   { ...newItem, name },
  ];
  const val = updateConfData(
   configurationItem?.Id || '-1',
   {
    ...configurationItemValue,
    [pageName]: newEntry,
   },
   confName,
  );
  if (!configurationItem?.Id) {
   dispatch(createClientConfigurationStart(val));
  } else {
   dispatch(updateClientConfigurationStart(val));
  }
 };

 const handleProChange = () => {
  const herePreset =
   tempColumnsPreset?.[pageName] || currentColumnsPreset?.[pageName];
  if (!herePreset) return;

  dispatch(
   changeCurrentPreset({
    page: pageName,
    type: confName,
    preset: {
     ...(herePreset as ColPresetType),
     isPro: !(herePreset || {})?.isPro,
    },
    temp: true,
   }),
  );
 };

 useEffect(() => {
  // if (confName === 'columns') {
  //  if (!currentColumnsPreset) {
  dispatch(
   getCurrentPresetStart({
    table: pageName,
    type: 'columns',
   }),
  );
  //  }
  // }
 }, []);

 useEffect(() => {
  // if (currentColumnsPreset && !tempColumnsPreset) {
  dispatch(
   changeCurrentPreset({
    page: pageName,
    type: 'columns',
    preset: currentColumnsPreset?.[pageName] as ColPresetType,
    temp: true,
   }),
  );
  // }
 }, [currentColumnsPreset]);

 useEffect(() => {
  if (
   success?.createClientConfiguration ||
   success?.updateClientConfiguration
  ) {
   dispatch(getClientConfigurationsStart({ cached: false }));
  }
  if (success?.getClientConfigurations && lastCreated) {
   const preset = currentPresets?.find((p) => p.name === lastCreated);
   if (preset) {
    dispatch(
     changeCurrentPreset({
      page: pageName,
      type: confName,
      preset,
      temp: true,
     }),
    );
   }
  }
 }, [success]);

 const addDisabled =
  (currentPreset as ColPresetType)?.columns &&
  typeof (currentPreset as ColPresetType).columns === 'object'
   ? Object.keys((currentPreset as ColPresetType).columns).length === 0
   : Array.isArray((currentPreset as ColPresetType)?.columns) &&
     (currentPreset as ColPresetType).columns.length === 0;

 const isLargerThanMd = useMediaQuery(themeOptions().breakpoints.up('md'));

 if (!isLargerThanMd) {
  return !currentPresets ? (
   <>...</>
  ) : (
   <Box sx={{ width: '100%', p: 3 }}>
    <Typography sx={{ fontSize: 18, fontWeight: 500, mb: '18px' }}>
     {confName === 'columns'
      ? t('colModal.colSettings')
      : t('filterModal.filterSettings')}
    </Typography>
    <FormControl sx={{ width: '100%' }}>
     <InputLabel htmlFor="presetSelect">Pasirinkite derinį</InputLabel>
     <Select
      id="presetSelect"
      onChange={(e: any, value: any) => {
       const preset = currentPresets?.find(
        (item) => item.name === e.target.value,
       );
       if (!preset) return;
       dispatch(
        changeCurrentPreset({
         page: pageName,
         type: confName,
         preset,
         temp: true,
        }),
       );
      }}
      value={currentPreset?.name || ''}
      label="Pasirinkite derinį"
      //  displayEmpty
     >
      {currentPresets?.map((item) => (
       <MenuItem key={item.name} value={item.name}>
        {item.name}
       </MenuItem>
      ))}
     </Select>
    </FormControl>
   </Box>
  );
 }

 return (
  <Box
   sx={{
    p: 3,
    minWidth: 330,
    position: 'sticky',
    top: 0,
    display: 'flex',
    flexDirection: 'column',
   }}
  >
   <Typography sx={{ fontSize: 18, fontWeight: 500, mb: '18px' }}>
    {confName === 'columns'
     ? t('colModal.colSettings')
     : t('filterModal.filterSettings')}
   </Typography>
   <Box
    sx={{
     display: 'flex',
     alignItems: 'center',
     justifyContent: 'space-between',
     mb: '14px',
    }}
   >
    <Typography
     sx={{ fontSize: 14, fontWeight: 500, color: th.palette.kemek.darkGray }}
    >
     {confName === 'columns'
      ? t('colModal.colPresets')
      : t('filterModal.filterPresets')}
    </Typography>
    <IconButton
     aria-label="create"
     disabled={addDisabled}
     onClick={() => handleCreate()}
     sx={() => ({
      opacity: addDisabled ? 0.5 : 1,
     })}
    >
     <IconPlus style={{ color: th.palette.kemek.blue }} />
    </IconButton>
   </Box>
   <Box
    sx={{
     borderRadius: '4px',
     border: `1px solid ${th.palette.kemek.lightestGray}`,
     mb: '12px',
     overflow: 'hidden',
    }}
   >
    {currentPresets?.map((item) => (
     <Box
      key={item.name || 'no-name'}
      onClick={() =>
       dispatch(
        changeCurrentPreset({
         page: pageName,
         type: confName,
         preset: item,
         temp: true,
        }),
       )
      }
      sx={{
       //    pointerEvents: item.name === currentItem ? 'none' : 'auto',
       cursor: 'pointer',
       fontSize: 12,
       transition: 'background-color 0.3s ease-in-out',
       backgroundColor:
        item.name === currentPreset?.name
         ? th.palette.kemek.bg1
         : 'transparent',
       p: '12px',
       borderBottom: `1px solid ${th.palette.kemek.lightestGray}`,
       '&:last-child': { borderBottom: 0 },
      }}
     >
      {item.name}{' '}
      {item.name === currentPreset?.name &&
       isPresetChanged(currentPresets, currentPreset) &&
       '*'}
     </Box>
    ))}
   </Box>
   {/* bottom menu */}
   <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
    <IconButton
     aria-label="delete"
     disabled={!currentPreset}
     onClick={handleDelete}
     sx={() => ({
      opacity: !currentPreset ? 0.5 : 1,
     })}
    >
     <IconDelete
      style={{ color: th.palette.kemek[!currentPreset ? 'gray' : 'red'] }}
     />
    </IconButton>
    <IconButton
     aria-label="duplicate"
     disabled={!currentPreset}
     onClick={() => handleDuplicate()}
     sx={() => ({
      opacity: !currentPreset ? 0.5 : 1,
     })}
    >
     <IconDuplicate
      style={{
       color: th.palette.kemek[!currentPreset ? 'gray' : 'darkestGray'],
      }}
     />
    </IconButton>
    <IconButton
     disabled={!currentPreset || !wasChanged}
     aria-label="revert"
     onClick={() => {
      if (!currentPreset) return;
      const revertedPreset = currentPresets?.find(
       (item) => item.name === currentPreset?.name,
      );
      if (confName === 'columns') {
       dispatch(
        changeCurrentPreset({
         page: pageName,
         type: 'columns',
         preset: revertedPreset as ColPresetType,
         temp: true,
        }),
       );
      }
     }}
     sx={() => ({
      ml: 'auto',
      opacity: !currentPreset || !wasChanged ? 0.5 : 1,
     })}
    >
     <IconDefault
      style={{
       color:
        th.palette.kemek[
         !currentPreset || !wasChanged ? 'gray' : 'darkestGray'
        ],
      }}
     />
    </IconButton>
    <IconButton
     disabled={!currentPreset || !wasChanged}
     aria-label="save"
     id="col-save-menu-button"
     aria-controls={saveMenuOpen ? 'col-save-menu-menu' : undefined}
     aria-haspopup="true"
     aria-expanded={saveMenuOpen ? 'true' : undefined}
     onClick={(event: React.MouseEvent<HTMLButtonElement>) => {
      setSaveMenuAnchorEl(event.currentTarget);
     }}
     sx={() => ({
      opacity: !wasChanged ? 0.5 : 1,
     })}
    >
     <IconSave
      style={{
       color: th.palette.kemek[!wasChanged ? 'gray' : 'blue'],
      }}
     />
    </IconButton>
    <Menu
     id="col-save-menu-menu"
     anchorEl={saveMenuAnchorEl}
     open={saveMenuOpen}
     onClose={() => setSaveMenuAnchorEl(null)}
     MenuListProps={{
      'aria-labelledby': 'col-save-menu-button',
      disablePadding: true,
     }}
    >
     <MenuItem
      onClick={() => {
       handleSave();
       setSaveMenuAnchorEl(null);
      }}
     >
      Išsaugoti
     </MenuItem>
     <MenuItem
      onClick={() => {
       handleCreate();
       setSaveMenuAnchorEl(null);
      }}
     >
      Išsaugoti kopiją
     </MenuItem>
    </Menu>
   </Box>
   {/* <Box
    sx={{
     fontSize: 10,
     lineBreak: 'anywhere',
     height: '300px',
     overflowY: 'scroll',
     mt: 2,
    }}
   >
    <pre>
     {JSON.stringify(JSON.parse(configurationItem?.Value || '{}'), null, 1)}
    </pre>
   </Box> */}
   {confName === 'columns' && (
    <Box sx={{ mt: 'auto' }}>
     <FormGroup>
      <FormControlLabel
       control={
        <Checkbox
         checked={
          (tempColumnsPreset?.[pageName] || currentColumnsPreset?.[pageName])
           ?.isPro || false
         }
         onChange={() => handleProChange()}
        />
       }
       label="„Pro“ versija"
      />
     </FormGroup>
    </Box>
   )}
  </Box>
 );
};
export default ModalConf;
